export default "__VITE_ASSET__D6NJ2XEH__"